export const dropdownTokens = {
  pillBackgroundColor: '',
  dropdownBorderColor: '',
  pillActiveBackgroundColor: '',
  selectButtonSecondaryColor: '',
  selectOptionBorderColor: '',
  hiContrast: '',
  dropdownActiveBgColor: '',
  dropdownBtnColor: '',
};

export const pillTabsTokens = {
  pillActiveBackgroundColor: '',
  pillBackgroundColor: '',
  pillBorderColor: '',
  pillActiveTextColor: '',
  pillTextColor: '',
  disabledPillTextColor: '',
};

export const headerV2Tokens = {
  ...dropdownTokens,
  ...pillTabsTokens,
  rowBackgroundColor: '',
  headerBoxShadowColor: '',
  hiContrast: '',
};

export const livescoreHeaderTokens = {
  ...pillTabsTokens,
  hiContrast: '',
  filtersContainerPrimaryBackgroundColor: '',
  dropdownBorderColor: '',
  dropdownBtnColor: '',
  dropdownArrowIconColor: '',
  dropdownArrowIconColorHover: '',
  pillActiveBackgroundColor: '',
  pillActiveTextColor: '',
  rowBackgroundColor: '',
  calendarHeaderBgcColor: '',
  dropdownCalendarIconColor: '',
};

export const oddsTokens = {
  oddsContainerPrimaryBgColor: '',
  oddsSelectionBackgroundColor: '',
  oddItemHoverColor: '',
  oddsSelectionBorderColor: '',
};

export const playoffTokens = {
  knockoutBgColor: '',
  knockoutHeaderBgColor: '',
  knockoutHeaderBorderColor: '',
  knockoutGameBgColor: '',
  knockoutGameBorderColor: '',
};
